import { render, staticRenderFns } from "./_referral.vue?vue&type=template&id=d479c45e&scoped=true&lang=pug&"
import script from "./_referral.vue?vue&type=script&lang=js&"
export * from "./_referral.vue?vue&type=script&lang=js&"
import style0 from "./_referral.vue?vue&type=style&index=0&id=d479c45e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d479c45e",
  null
  
)

export default component.exports